import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'application';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);


export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
